import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux'
import './Video09Navigator.scss'
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import { GetBaseUrl } from '@/utils/ConfigHelper'

class Video09Navigator extends Component {

  render() {
    const { currentPath } = this.props
    return (
      <>
        <div className={`video09-new_navigatorAreaWrapper prohibit-drag ${(currentPath === '/' || currentPath === '/home') && 'top-fixed'}`}>
          <div className="layout">
            <div className="logo_area">
              <NavLink to="/home" className="item">
                <img src="https://front.videomonster.com/images-u6yd72dy/web/video09/video09-logo.webp" alt="logo" />
              </NavLink>
            </div>
            <div className="header">
              <div className='header-left'>
                <NavLink to="/order" className="item"><p>주문하기</p></NavLink>
                <div className="item" onClick={() => { /*window.open('https://video09.zendesk.com/hc/ko', '_blank')*/ }}>
                  <p>FAQ</p>
                </div>
                <div className="item" onClick={() => window.open(`${GetBaseUrl()}/chat?provider=video09`, '_blank')}>
                  <p>세금계산서 발행</p>
                </div>
              </div>
              <NavLink to="/check" className="item"><p>주문조회</p></NavLink>
            </div>

            <ClickAwayListener onClickAway={e => {
              e.preventDefault()
            }}>
            </ClickAwayListener>
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = state => ({
  currentPath: state.currentPathStore.currentPath
})

export default connect(
  mapStateToProps,
  null
)(Video09Navigator)